export default "__VITE_ASSET__VM3RHSWN__"